import { NgModule } from '@angular/core'
import { EffectsModule } from '@ngrx/effects'
import { IonicPageModule } from 'ionic-angular'
import { Plncmm10000sc0000Page } from './plncmm10000sc00-00.component.page'
import { Plncmm10000sc0000PageEffects } from './plncmm10000sc00-00.effects.page'
import { WidgetModule } from '../../../../widgets/widget.module'

/**
 * Dashboardモジュール
 * @author nabla2.metamodel.generator
 */
@NgModule({
  declarations: [
    Plncmm10000sc0000Page,
  ],
  imports: [
    IonicPageModule.forChild(Plncmm10000sc0000Page),
    EffectsModule.forFeature([Plncmm10000sc0000PageEffects]),
    WidgetModule
  ],
  entryComponents: [
    Plncmm10000sc0000Page,
  ]
})
export class Plncmm10000sc0000PageModule {}


// WEBPACK FOOTER //
// ./src/features/cmnfnc-base/pages/plncmm10000sc00-00/plncmm10000sc00-00.component.page.module.ts